import NextLink from 'next/link';

import {
  Callout,
  PageIntro,
  NavLink,
} from '@frontendmentorio/design-system-v2';

import Discord from 'features/shared/Discord';
import FAQs from 'features/shared/FAQs';

export default function Contact() {
  return (
    <>
      <PageIntro
        className="text-neutral-500"
        heading="Facing any of these questions?"
      >
        <p>
          If you’ve got a question, there’s a good chance we’ve answered it in
          our FAQs. You’ll see some of our most common ones below. If you’re
          still stuck, please feel free to get in touch using the email address
          at the bottom.
        </p>
      </PageIntro>

      <div className="flex flex-col gap-8 pb-6 px-5">
        <div className="container-sm flex flex-col gap-5 items-center">
          <FAQs>
            <FAQs.FAQ question="What does this platform do, and how will it help me?" />
            <FAQs.FAQ question="Is it free?" />
            <FAQs.FAQ question="Can I use these projects in my portfolio?" />
            <FAQs.FAQ question="Can I use libraries/frameworks on these projects?" />
            <FAQs.FAQ question="How can I get help if I'm stuck on a challenge?" />
            <FAQs.FAQ question="How do I submit my solution?" />
            <FAQs.FAQ question="How do I edit my solution?" />
          </FAQs>

          <NavLink href="/faq" level="tertiary">
            View all FAQs
          </NavLink>
        </div>

        <Discord />

        <Callout
          className="container-xl"
          heading="Still got a question?"
          theme="light"
        >
          <p className="max-w-prose">
            Contact us at{' '}
            <NextLink
              className="underline hover:no-underline"
              href="mailto:hi@frontendmentor.io"
            >
              hi@frontendmentor.io
            </NextLink>{' '}
            and we’ll get back to you as soon as we can. Heads up that reply
            times are usually slower over the weekend.
          </p>
        </Callout>
      </div>
    </>
  );
}
